module.exports = __webpack_public_path__ + "static/logo-token-41e6f7b33a1dbffa0962728de4772e0c.png";